var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as tts from "./tts";
import { fetchApi, getFromLocalStorage, saveInLocalStorage } from "./helpers";
import { HttpMethods } from "tagwalk-api-client/assets/js/common/enums";
import * as crypto from "crypto";
import { createResponse, getCurrentFingerprint } from "@js/common/helpers/fingerprint";
export var checkFingerprint = function () { return __awaiter(void 0, void 0, void 0, function () {
    var currentHashedFingerprint, paywallSubscription, isSameDevice, fetchedFingerprint, error_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                currentHashedFingerprint = getFromLocalStorage('paywall_user_fingerprint');
                paywallSubscription = null;
                isSameDevice = true;
                fetchedFingerprint = '';
                _b.label = 1;
            case 1:
                _b.trys.push([1, 5, , 6]);
                return [4, fetchSubscription()];
            case 2:
                paywallSubscription = _b.sent();
                if (!paywallSubscription) {
                    return [2, createResponse(currentHashedFingerprint)];
                }
                fetchedFingerprint = (_a = paywallSubscription === null || paywallSubscription === void 0 ? void 0 : paywallSubscription['user_fingerprint']) !== null && _a !== void 0 ? _a : '';
                if (!!currentHashedFingerprint) return [3, 4];
                return [4, updateFingerprint(paywallSubscription)];
            case 3:
                currentHashedFingerprint = _b.sent();
                _b.label = 4;
            case 4: return [3, 6];
            case 5:
                error_1 = _b.sent();
                return [2, createResponse(currentHashedFingerprint, fetchedFingerprint)];
            case 6:
                isSameDevice = fetchedFingerprint === '' ? true : fetchedFingerprint === currentHashedFingerprint;
                return [2, createResponse(currentHashedFingerprint, fetchedFingerprint, isSameDevice)];
        }
    });
}); };
export var hitAnalytics = function (subscription, currentHashedFingerprint) {
    var _a;
    var main = document.querySelector('main');
    var route = main === null || main === void 0 ? void 0 : main.getAttribute('data-route');
    tts.custom({
        event: 'paywall_user_fingerprint_generate',
        uri: document.location,
        utm_content: subscription['id'],
        previous_device_fingerprint: (_a = subscription === null || subscription === void 0 ? void 0 : subscription['user_fingerprint']) !== null && _a !== void 0 ? _a : '',
        new_device_fingerprint: currentHashedFingerprint
    }, route);
};
export var updateFingerprint = function (paywallSubscription) { return __awaiter(void 0, void 0, void 0, function () {
    var currentFingerprint, currentHashedFingerprint, daysToAdd, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                currentFingerprint = getCurrentFingerprint();
                currentHashedFingerprint = crypto.createHash('sha1').update(currentFingerprint).digest('hex');
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4, storeFingerprint(paywallSubscription['id'], currentHashedFingerprint)];
            case 2:
                _a.sent();
                daysToAdd = 7;
                saveInLocalStorage('paywall_user_fingerprint', currentHashedFingerprint, daysToAdd * 24 * 60 * 60 * 1000);
                hitAnalytics(paywallSubscription, currentHashedFingerprint);
                return [3, 4];
            case 3:
                error_2 = _a.sent();
                return [3, 4];
            case 4: return [2, currentHashedFingerprint];
        }
    });
}); };
var storeFingerprint = function (id, fingerprint) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, fetchApi('api_user_paywall_subscription_patch', HttpMethods.patch, { id: id }, { 'fingerprint': fingerprint })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    return [2, null];
                }
                return [4, response.json()];
            case 2: return [2, _a.sent()];
        }
    });
}); };
var fetchSubscription = function () { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, fetchApi('api_user_paywall_subscription_me', HttpMethods.get)];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    return [2, null];
                }
                if (response.status === 204) {
                    return [2, null];
                }
                return [4, response.json()];
            case 2: return [2, _a.sent()];
        }
    });
}); };
